import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-caste-verification-form',
  templateUrl: './caste-verification-form.component.html',
  styleUrls: ['./caste-verification-form.component.css']
})
export class CasteVerificationFormComponent implements OnInit {

  title = "Caste Verification";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/caste-verification/caste-verification-form/caste-verification-form.component.ts